import { render, staticRenderFns } from "./shiftManagementDashboard.vue?vue&type=template&id=caa4a7fc"
import script from "./shiftManagementDashboard.vue?vue&type=script&lang=js"
export * from "./shiftManagementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports